const labels = {
  productAndOffers: 'Products & Offers',
  accounts: 'Accounts',
  referrals: 'Referrals',
  profile: 'Profile',
}

export { labels }
